import {
  ActionButton,
  Badge,
  OfficeButton,
  OfficeHeader,
  Paginator,
  TableComponent,
} from "components";
import React, { FC } from "react";
import { useAppNavigate, useAppSearch } from "_graphql/cache/auth";

import CreateContainer from "./create";
import PromoteContainer from "./promote";
import RemovePromotionContainer from "./remove";
import UpdateContainer from "./update";
import ViewContainer from "./view";
import _ from "lodash";
import moment from "moment";
import { usePagination } from "hooks";
import { usePromotions } from "hooks/data/use-promotions";

type Props = {};

const PromotionsPage: FC<Props> = (props) => {
  const navigate = useAppNavigate();
  const searchParams = useAppSearch();
  const { search, limit, setPage, offset } = usePagination();
  const { promotions, refetch, loading, count } = usePromotions({
    countInput: {},
    input: {
      limit,
      offset,
    },
  });
  return (
    <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
      <OfficeHeader
        renderActions={() => (
          <OfficeButton
            size="sm"
            onClick={() => navigate({ search: { modal: "create" } })}
          >
            Create Promotion
          </OfficeButton>
        )}
      />
      <div className="flex flex-1 overflow-y-auto">
        <div className="flex-1 mx-auto min-w-0 py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
          <TableComponent
            title={"promotions"}
            loading={loading}
            columns={[
              {
                accessor: "name",
                name: "Name",
              },
              {
                accessor: "type",
                name: "Type",
                render: (row) => _.startCase(row.type || ""),
              },
              {
                accessor: "start_datetime",
                name: "Start Date",
                render: (row) => moment(row.start_datetime).format("MMMM Do YYYY, hh:mm a"),
              },
              {
                accessor: "end_datetime",
                name: "End Date",
                render: (row) => moment(row.end_datetime).format("MMMM Do YYYY, hh:mm a"),
              },
              {
                accessor: "createdBy.employee_first_name",
                name: "Created By",
                render: (row) => `${_.startCase(row.createdBy?.employee_first_name || "")} ${_.startCase(row.createdBy?.employee_last_name || "")}`,
              },
              {
                accessor: "status",
                name: "Status",
                render: (row) => (
                  <Badge
                    status={row.status === "ACTIVE" ? "success" : "error"}
                    label={_.startCase(row.status || "")}
                  />
                ),
              },
              {
                accessor: "actions",
                name: "Actions",
                render: (row) => (
                  <div className="flex space-x-2">
                    <ActionButton
                      action="view"
                      onClick={() =>
                        navigate({
                          search(prev) {
                            return {
                              ...prev,
                              id: row.id || "",
                              modal: "view",
                            };
                          },
                        })
                      }
                    />
                    <ActionButton
                      action="update"
                      onClick={() =>
                        navigate({
                          search(prev) {
                            return {
                              ...prev,
                              id: row.id || "",
                              modal: "update",
                            };
                          },
                        })
                      }
                    />
                    <ActionButton
                      action="alert"
                      onClick={() =>
                        navigate({
                          search(prev) {
                            return {
                              ...prev,
                              id: row.id || "",
                              modal: "alert",
                            };
                          },
                        })
                      }
                    />
                    <ActionButton
                      action="remove"
                      extraClassName="text-red-600"
                      onClick={() =>
                        navigate({
                          search(prev) {
                            return {
                              ...prev,
                              id: row.id || "",
                              modal: "remove",
                            };
                          },
                        })
                      }
                    />

                  </div>
                ),
              },
            ]}
            data={promotions}
            refetch={refetch}
            pagination={() => (
              <Paginator
                offset={offset}
                limit={limit}
                totalItems={count}
                currentSize={promotions.length}
                setOffset={setPage}
              />
            )}
          />
        </div>
      </div>

      {searchParams?.modal === "create" && (
        <CreateContainer
          open={searchParams?.modal === "create"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "create" : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "view" && (
        <ViewContainer
          open={searchParams?.modal === "view"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "view" : undefined,
                  id: val ? searchParams.id : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "remove" && (
        <RemovePromotionContainer
          open={searchParams?.modal === "remove"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "remove" : undefined,
                  id: val ? searchParams.id : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "update" && (
        <UpdateContainer
          open={searchParams?.modal === "update"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "update" : undefined,
                  id: val ? searchParams.id : undefined,
                };
              },
            })
          }
        />
      )}
      {searchParams?.id && searchParams?.modal === "alert" && (
        <PromoteContainer
          open={searchParams?.modal === "alert"}
          setOpen={(val) =>
            navigate({
              search(prev) {
                return {
                  ...prev,
                  modal: val ? "alert" : undefined,
                  id: val ? searchParams.id : undefined,
                };
              },
            })
          }
        />
      )}
    </main>
  );
};

export default PromotionsPage;
